import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ContentCarrier from './content-carrier-model'
import {
  CreateContentCarrierAsync,
  DeleteContentCarrierAsync,
  LoadContentCarriersAsync,
} from './contentCarrier-thunk'
const initialState: contentCarrierSliceState = {
  contentCarrier: [],
  selected_contentCarrier: '',
  is_loading_contentCarrier: false,
  is_creating_contentCarrier: false,
  is_deleting_contentCarrier: false,
}
export interface contentCarrierSliceState {
  contentCarrier: ContentCarrier[]
  selected_contentCarrier?: string
  is_loading_contentCarrier: boolean
  is_creating_contentCarrier: boolean
  is_deleting_contentCarrier: boolean
}
export const contentCarrierSlice = createSlice({
  name: 'contentCarrier',
  initialState,
  reducers: {
    setSelectedcontentCarrier: (state, action) => {
      state.selected_contentCarrier = action.payload
    },
    clearStatecontentCarrier: (state) => {
      state.contentCarrier = []
      state.is_loading_contentCarrier = false
      state.is_creating_contentCarrier = false
      state.is_deleting_contentCarrier = false
    },
    mergecontentCarrier: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_contentCarrier = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.contentCarrier = merge(state.contentCarrier, payload) as any
        }
      }
    },

    add_contentCarrier: (state, action) => {
      if (action.payload) {
        state.contentCarrier = [...state.contentCarrier, action.payload]
      }
    },
    set_contentCarrier: (state, action) => {
      let { key, value, id } = action.payload
      state.contentCarrier = state.contentCarrier.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadContentCarriersAsync.pending, (state) => {
      state.is_loading_contentCarrier = true
    })
    builder.addCase(LoadContentCarriersAsync.fulfilled, (state, action) => {
      state.is_loading_contentCarrier = false
      if (action.payload) {
        state.contentCarrier = action.payload
      }
    })
    builder.addCase(LoadContentCarriersAsync.rejected, (state) => {
      state.is_loading_contentCarrier = false
    })
    builder.addCase(CreateContentCarrierAsync.pending, (state) => {
      state.is_creating_contentCarrier = true
    })
    builder.addCase(CreateContentCarrierAsync.fulfilled, (state) => {
      state.is_creating_contentCarrier = false
    })
    builder.addCase(CreateContentCarrierAsync.rejected, (state) => {
      state.is_creating_contentCarrier = false
    })
    builder.addCase(DeleteContentCarrierAsync.pending, (state) => {
      state.is_deleting_contentCarrier = true
    })
    builder.addCase(DeleteContentCarrierAsync.fulfilled, (state, action) => {
      state.is_deleting_contentCarrier = false
      if (state.contentCarrier) {
        state.contentCarrier = state.contentCarrier.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteContentCarrierAsync.rejected, (state) => {
      state.is_deleting_contentCarrier = false
    })

    builder.addCase(autoThunks.store_content_carrier.pending, (state) => {
      state.is_loading_contentCarrier = true
    })
    builder.addCase(
      autoThunks.store_content_carrier.fulfilled,
      (state, action) => {
        state.is_loading_contentCarrier = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.store_content_carrier.rejected, (state) => {
      state.is_loading_contentCarrier = false
    })

    builder.addCase(autoThunks.get_content_carrier.pending, (state) => {
      state.is_loading_contentCarrier = true
    })
    builder.addCase(
      autoThunks.get_content_carrier.fulfilled,
      (state, action) => {
        state.is_loading_contentCarrier = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_content_carrier.rejected, (state) => {
      state.is_loading_contentCarrier = false
    })
  },
})

function handleResult(action: any, state: contentCarrierSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_contentCarrier = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.contentCarrier = merge(state.contentCarrier, payload) as any
    }
  }
}

export const {
  clearStatecontentCarrier,
  setSelectedcontentCarrier,
  set_contentCarrier,
  mergecontentCarrier,
  add_contentCarrier,
} = contentCarrierSlice.actions

export const get_contentCarrier =
  (id?: string) =>
  (state: {
    contentCarrier: {
      contentCarrier: ContentCarrier[]
    }
  }): ContentCarrier | null => {
    let temp = state?.contentCarrier?.contentCarrier?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.contentCarrier?.contentCarrier[0] || null
  }
export const get_selected_contentCarrier = (state: {
  contentCarrier: contentCarrierSliceState
}): ContentCarrier | null => {
  let id = state?.contentCarrier?.selected_contentCarrier
  let temp = state?.contentCarrier?.contentCarrier?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_contentCarrier = (state: {
  contentCarrier: {
    contentCarrier: ContentCarrier[]
  }
}): ContentCarrier[] => {
  let temp = state?.contentCarrier?.contentCarrier
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_contentCarrier_busy = (state: {
  contentCarrier: contentCarrierSliceState
}) => {
  return (
    state?.contentCarrier.is_deleting_contentCarrier ||
    state?.contentCarrier.is_loading_contentCarrier ||
    state?.contentCarrier.is_creating_contentCarrier
  )
}
export const is_deleting_contentCarrier_busy = (state: {
  contentCarrier: contentCarrierSliceState
}) => {
  return state?.contentCarrier.is_deleting_contentCarrier
}
export const is_loading_contentCarrier_busy = (state: {
  contentCarrier: contentCarrierSliceState
}) => {
  return state?.contentCarrier.is_loading_contentCarrier
}
export const is_creating_contentCarrier_busy = (state: {
  contentCarrier: contentCarrierSliceState
}) => {
  return state?.contentCarrier.is_creating_contentCarrier
}

export default contentCarrierSlice.reducer
